module.exports = __webpack_public_path__ + "7ac1390902567cf1757699d797bd0d78.png";